module.exports = __webpack_public_path__ + "img/Close_Line_18px_2_Icon_white.3b3df04a.svg";